import { Box, Button, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Filter from "../../assets/svg/Filter";
import TextFieldBox from "../../components/common/TextField";
import TradeView from "../../components/TradeView";
import { colors } from "../../utils/colors/Index";
import CreateCalls from "./CreateCalls";
import RecentCalls from "./RecentCalls";
import { apiGet, apiPatch } from "../../utils/Api/ApiCalls";
import { API_ROUTES } from "../../utils/Api/ApiConfig";
import Loader from "../../components/common/Loader";

function Dashboard() {
  const Navigation = useNavigate();
  // const dummyDataArray = [
  //   {
  //     companyName: "PIRAMAL PHARMA LIMITED",
  //     date: "15-oct-2024",
  //     profitPotential: "8.35%",
  //     entryPrice: 500,
  //     targetPrice1_Status: "success",
  //     targetPrice1_created_at: "12:53 PM, Today",
  //     targetPrice2_Status: "failed",
  //     targetPrice2_created_at: "12:53 PM, Today",
  //     targetPrice1: 300,
  //     targetPrice2: 400,
  //     stopLoss: 450,
  //     stopLoss_Status: "success",
  //     stopLoss_created_at: "12:53 PM, Today",
  //   },
  //   {
  //     companyName: "RELIANCE INDUSTRIES",
  //     date: "18-oct-2024",
  //     profitPotential: "5.25%",
  //     entryPrice: 2500,
  //     targetPrice1: 2600,
  //     targetPrice2: 2700,
  //     stopLoss: 2400,
  //     stopLoss_Status: "failed",
  //     targetPrice1_Status: "success",
  //     targetPrice1_created_at: "12:53 PM, Today",
  //     targetPrice2_Status: "success",
  //     targetPrice2_created_at: "12:53 PM, Today",
  //     stopLoss_created_at: "12:53 PM, Today",
  //   },
  //   {
  //     companyName: "HDFC BANK",
  //     date: "20-oct-2024",
  //     profitPotential: "6.15%",
  //     entryPrice: 1500,
  //     targetPrice1: 1550,
  //     targetPrice2: 1600,
  //     stopLoss: 1450,
  //     stopLoss_Status: "success",
  //     targetPrice1_Status: "success",
  //     targetPrice1_created_at: "12:53 PM, Today",
  //     targetPrice2_Status: "failed",
  //     targetPrice2_created_at: "12:53 PM, Today",
  //     stopLoss_created_at: "12:53 PM, Today",
  //   },
  //   {
  //     companyName: "TATA CONSULTANCY SERVICES",
  //     date: "22-oct-2024",
  //     profitPotential: "7.50%",
  //     entryPrice: 3200,
  //     targetPrice1: 3300,
  //     targetPrice2: 3400,
  //     stopLoss: 3100,
  //     stopLoss_Status: "success",
  //     targetPrice1_Status: "failed",
  //     targetPrice1_created_at: "12:53 PM, Today",
  //     targetPrice2_Status: "failed",
  //     targetPrice2_created_at: "12:53 PM, Today",
  //     stopLoss_created_at: "12:53 PM, Today",
  //   },
  //   {
  //     companyName: "INFOSYS",
  //     date: "25-oct-2024",
  //     profitPotential: "6.75%",
  //     entryPrice: 1800,
  //     targetPrice1: 1900,
  //     targetPrice2: 2000,
  //     stopLoss: 1750,
  //     stopLoss_Status: "success",
  //     targetPrice1_Status: "success",
  //     targetPrice1_created_at: "12:53 PM, Today",
  //     targetPrice2_Status: "success",
  //     targetPrice2_created_at: "12:53 PM, Today",
  //     stopLoss_created_at: "12:53 PM, Today",
  //   },
  //   {
  //     companyName: "HINDUSTAN UNILEVER",
  //     date: "28-oct-2024",
  //     profitPotential: "4.85%",
  //     entryPrice: 2400,
  //     targetPrice1: 2500,
  //     targetPrice2: 2550,
  //     stopLoss: 2350,
  //     stopLoss_Status: "failed",
  //     targetPrice1_Status: "failed",
  //     targetPrice1_created_at: "12:53 PM, Today",
  //     targetPrice2_Status: "failed",
  //     targetPrice2_created_at: "12:53 PM, Today",
  //     stopLoss_created_at: "12:53 PM, Today",
  //   },
  //   {
  //     companyName: "BAJAJ FINANCE",
  //     date: "30-oct-2024",
  //     profitPotential: "9.10%",
  //     entryPrice: 7200,
  //     targetPrice1: 7400,
  //     targetPrice2: 7600,
  //     stopLoss: 7000,
  //     stopLoss_Status: "success",
  //     targetPrice1_Status: "success",
  //     targetPrice1_created_at: "12:53 PM, Today",
  //     targetPrice2_Status: "success",
  //     targetPrice2_created_at: "12:53 PM, Today",
  //     stopLoss_created_at: "12:53 PM, Today",
  //   },
  //   {
  //     companyName: "LARSEN & TOUBRO",
  //     date: "05-nov-2024",
  //     profitPotential: "7.00%",
  //     entryPrice: 2000,
  //     targetPrice1: 2100,
  //     targetPrice2: 2200,
  //     stopLoss: 1950,
  //     stopLoss_Status: "success",
  //     targetPrice1_Status: "success",
  //     targetPrice1_created_at: "12:53 PM, Today",
  //     targetPrice2_Status: "failed",
  //     targetPrice2_created_at: "12:53 PM, Today",
  //     stopLoss_created_at: "12:53 PM, Today",
  //   },
  // ];
  const [loader, setLoader] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all");
  const [filteredData, setFilteredData] = useState([]);
  const [callData, setCallData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [render, setRender] = useState(false);

  useEffect(() => {
    if (callData?.length) {
      handleTabChange(undefined, statusFilter);
    }
  }, [callData]);

  const fetchCallData = async () => {
    setLoader(true);
    try {
      const response = await apiGet(API_ROUTES.GET_CALLS);
      if (response?.status === 200) {
        const result = response?.data?.calls.sort(
          (a, b) => new Date(b.updatedOn) - new Date(a.updatedOn)
        );
        setCallData(result);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchCallData();
  }, [render]);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    handleIncludesSearchChange(callData, value, statusFilter);
  };

  const removeWhiteSpace = (str) => {
    if (!str) return "";
    let result = str.replace(/\s+/g, "")?.toLowerCase();
    return result;
  };

  const handleIncludesSearchChange = (list, searchValue, status) => {
    if (searchValue) {
      const filtered = list.filter((item) =>
        removeWhiteSpace(item.callName)?.includes(removeWhiteSpace(searchValue))
      );
      if (status === "all") setFilteredData(filtered);
      else handleFilter(filtered, status);
    } else {
      if (status === "all") setFilteredData(list);
      else handleFilter(list, status);
    }
  };

  // const filteredData = searchQuery
  //   ? [
  //       ...callData.filter((item) =>
  //         item.callName?.toLowerCase()?.startsWith(searchQuery?.toLowerCase())
  //       ),
  //       ...callData.filter(
  //         (item) =>
  //           item.callName
  //             ?.toLowerCase()
  //             ?.includes(searchQuery?.toLowerCase()) &&
  //           !item.callName
  //             ?.toLowerCase()
  //             ?.startsWith(searchQuery?.toLowerCase())
  //       ),
  //     ]
  //   : callData;
  // useEffect(() => {
  //   const newData = searchQuery
  //     ? [
  //         ...callData.filter((item) =>
  //           item.callName?.toLowerCase()?.startsWith(searchQuery?.toLowerCase())
  //         ),
  //         ...callData.filter(
  //           (item) =>
  //             item.callName
  //               ?.toLowerCase()
  //               ?.includes(searchQuery?.toLowerCase()) &&
  //             !item.callName
  //               ?.toLowerCase()
  //               ?.startsWith(searchQuery?.toLowerCase())
  //         ),
  //       ]
  //     : callData;

  //   setFilteredData(newData);
  // }, [searchQuery, callData]);
  const TabData = [
    {
      name: "Open",
      value: "Open",
    },
    {
      name: "Closed",
      value: "Closed",
    },
    {
      name: "All",
      value: "all",
    },
  ];
  const handleFilter = (list, value) => {
    const filtered = list.filter((item) => item?.status === value);
    console.log(filtered, value);
    setFilteredData(filtered);
  };

  const handleTabChange = (event, newValue) => {
    setStatusFilter(newValue);
    // if (newValue === "all") {
    //   setFilteredData(callData);
    // } else {
    handleIncludesSearchChange(callData, searchQuery, newValue);
    // }
  };
  const handleDeleteSingleSelected = async (id) => {
    console.log("single selected", { callIds: id });

    try {
      setLoader(true);
      // API call to delete multiple calls
      await apiPatch(API_ROUTES.DELETE_PLAN, {
        callIds: [id],
      });

      // Remove deleted calls from list
      setFilteredData((prev) =>
        prev.filter((call) => !filteredData.includes(call._id))
      );

      // reset selection
      setLoader(false);
    } catch (err) {
      console.error(err);
      setLoader(false);
    }
  };
  return (
    <Container>
      <LeftColumn>
        <RecentCallsContainer>
          <RecentCallsHeader>
            <Title variant="h5">Recent Calls</Title>
            <Box
              sx={{
                display: "flex",
                width: "40%",
              }}
            >
              <StatusButtonContainer>
                {TabData?.map((item, index) => (
                  <StatusButtonSubContainer key={index}>
                    <ButtonContainer
                      name={item?.name}
                      selected={statusFilter === item?.value}
                      onClick={(e) => handleTabChange(e, item?.value)}
                    >
                      {item?.name}
                    </ButtonContainer>
                  </StatusButtonSubContainer>
                ))}
              </StatusButtonContainer>
            </Box>
            <FilterOptions>
              <Box width={"50%"}>
                <TextFieldBox
                  value={searchQuery}
                  placeholder="Search"
                  handleChange={handleSearchChange}
                />
              </Box>
              <Filter />
              <ViewAllText variant="body2" onClick={() => Navigation("/stock")}>
                View All
              </ViewAllText>
            </FilterOptions>
          </RecentCallsHeader>
          {loader ? (
            <Loader />
          ) : (
            <ScrollContainer>
              {filteredData?.map((item, index) => (
                <RecentCalls
                  key={index}
                  item={item}
                  setLoader={setLoader}
                  setCallData={setCallData}
                  closeCallApiType="default"
                  onDelete={handleDeleteSingleSelected}
                />
              ))}
            </ScrollContainer>
          )}
        </RecentCallsContainer>
      </LeftColumn>
      <RightColumn>
        <CreateCalls setRender={setRender} />
      </RightColumn>
    </Container>
  );
}

export default Dashboard;

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  width: "100%",
  padding: "1rem",
  columnGap: "1rem",
  height: "100%",
  overflowY: "auto",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

const LeftColumn = styled(Box)(({ theme }) => ({
  width: "70%",
  height: "100%",

  display: "flex",
  flexDirection: "column",
  rowGap: "1rem",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "auto",
  },
}));

const TradeViewContainer = styled(Box)(() => ({
  height: "50%",
}));

const RecentCallsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: colors.background.primary,
  borderRadius: "16px",
  boxShadow: "0px 1px 2px 1px #DCDCDC",
  height: "100%",
  padding: "1rem",
  [theme.breakpoints.down("md")]: {
    height: "auto",
  },
}));

const RecentCallsHeader = styled(Box)(() => ({
  display: "flex",
  width: "100%",
  alignItems: "center",
  marginBottom: "1rem",
}));

const Title = styled(Typography)(() => ({
  fontWeight: 600,
  width: "20%",
}));

const FilterOptions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  columnGap: "1rem",
  width: "60%",
}));

const ViewAllText = styled(Typography)(() => ({
  cursor: "pointer",
  color: colors.blue,
}));

const ScrollContainer = styled(Box)(() => ({
  height: "100%",
  overflowY: "auto",
}));

const RightColumn = styled(Box)(({ theme }) => ({
  width: "30%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    marginTop: "1rem",
  },
}));
const StatusButtonContainer = styled(Box)(({ theme }) => ({
  // border: "1px solid #D9D9D9",
  width: { lg: "40%", xl: "40%", md: "100%", sm: "100%", xs: "100%" },
  padding: "4px",
  display: "flex",
  flexDirection: "row",
  borderRadius: "8px",
  columnGap: "0.5rem",
  justifyContent: "space-around",
  // backgroundColor: "#FFF3F3",
  [theme.breakpoints.down("md")]: {
    color: "#151515",
    width: "400px",
    padding: "2px",
    borderRadius: "4px",
  },
}));
const StatusButtonSubContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  // textAlign:'center'
}));
const ButtonContainer = styled(Button)(({ selected }) => ({
  gap: "2px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textTransform: "none",
  color: selected ? "#FFC200" : "black",
  // backgroundColor: selected ? "#FFF9E6" : "transparent",
  borderRadius: "0",
  borderBottom: selected ? "2px solid #FFC200" : "none",
  fontSize: "16px",
  "&:hover": {
    backgroundColor: selected ? "#FFF9E6" : "#FFF9E6",
  },
}));
